const langtrans={
      fhssyy:["返回上一页","Back"],
      hffajb:["回复方案及报价详情","Reply to plan and quotation"],
      qnzffz:["请您在30分钟内进行报价，逾期将视为放弃此案件的报价","Please make your quotation within 30 minutes to avoid being overdue"],
      jyfa:["救援方案","Operation plan"],
      tjfj:["添加附件","Attach files"],
      ryyjyf:["如有救援方案附件","Please upload files of operation plan "],
      qsscz:["请上传","if any"],
      sc:["删除","Delete"],
      txxbjj:["填写报价","Quotation"],
      jyfy:["救援费用（转运、死亡处理、遗体处理、代办人派遣费用）","Operation fee（Repatriation/evacuation/mortal remains handling/agent dispatch fee）"],
      ylfy:["医疗费用","Medical cost"],
      ajfy:["案件费用","Case fee"],
      ztbtbj:["整体报价","Total"],
      wmxe:["无限额","unlimited"],
      xe:["限额","limited"],
      ssym:["说明：","Description："],
      wm:["无","None"],
      tjhf:["添加回复","Add a reply"],
      tdsjbj:["提交报价及方案","Submit"],
      qxhf:["取消回复","Cancel reply"],
      qrhf:["确认回复","Confirm reply"],
      sfpqrt:["是否确认提交","Are you sure you want to submit?"],
      xgyx:["修改一下","Modify"],
      q:["确","Confirm"],
      d:["定",""],
      ssczfa:["上传方案及报价","upload solution and quotation"],
      fjmccc:["附件名称","Annex name"],
      fjddz:["附件地址","Annex location"],
      qd:["确定","Confirm"],
      rmb:["人民币","Ren Min Bi"],
      my:["美元","U.S. Dollar"],
      oy:["欧元","Euro"],
      ry:["日元","Japanese Yen"],
      xttb:["新台币","New Taiwan Currency"],
      qsrsss:["请输入数字，而非其他","Please enter numbers only"],
      qssczf:["请上传附件","Please upload the annex"],
      qtxxbj:["请添写报价","Please fill in the quotation"],
      qqrsrd:["请确认输入的数值，总价必须是其他三项之和","en_translated"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/inf.vue.trans.js